import { RatedSide, RatingsOfAPerson } from './outing-ratings.service';

export type CardSide = 'organiser' | 'participant';

/**
 * Which sides of the card are offered. The organiser side is left out for
 * somebody nobody ever rated as an organiser, which is how the card hides it
 * for a person who never organised. The participant side is always there: it
 * is what the card says "no rating yet" on.
 */
export function sidesOffered(ratings: RatingsOfAPerson): CardSide[] {
  return ratings.organiser.count > 0 ? ['organiser', 'participant'] : ['participant'];
}

/** The side opened first: the one more people rated, the organiser side on a tie. */
export function sideOpenedFirst(ratings: RatingsOfAPerson): CardSide {
  return ratings.organiser.count > 0 && ratings.organiser.count >= ratings.participant.count
    ? 'organiser'
    : 'participant';
}

/** A side shows its score once the API gives one, which it does from three people. */
export function isShown(side: RatedSide): boolean {
  return side.score !== null;
}

/** « 4,3 » for a French reader, "4.3" for an English one, always one decimal. */
export function scoreLabel(score: number, language: string): string {
  return new Intl.NumberFormat(language === 'fr' ? 'fr-FR' : 'en-GB', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(score);
}
